/* eslint-disable no-confusing-arrow, react/jsx-curly-newline */
/* eslint-disable @typescript-eslint/no-use-before-define */

import React, { useState, useEffect } from 'react';

// Redux
import { useDispatch, useSelector } from 'react-redux';

// React Router Dom

// Material
import Box from '@material-ui/core/Box';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import ImgMedia from '@material-ui/core/CardMedia';

// Icons
import ExpandMore from '@material-ui/icons/ExpandMore';
import Settings from '@material-ui/icons/Settings';

// Clsx
import clsx from 'clsx';

// Constants
import IMAGES from 'constants/images';

// Helpers
import { setCompany } from 'helpers/auth';

// Actions
import { setOpen } from 'store/ducks/dialogs/actions';
import * as TransportOperatorsActions from 'store/ducks/transportOperators/actions';

// Types
import { ApplicationState } from 'store';

// Constants
import PATH from 'constants/basePath';

// Components
import { MenuCollapse } from 'components/Drawer/components';
import { ImageUpload } from '../components/ImageUpload';

// Styles
import useStyles from './supervisorHeader.styles';

const SupervisorHeader: React.FC = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const CONSORTION_TYPE = 1;

  const [isConsortion, setisConsortion] = useState(false);

  const transportOperatorSelected = useSelector(
    (state: ApplicationState) =>
      state.transportOperators.transportOperatorSelected,
  );

  const workspaces = useSelector(
    (state: ApplicationState) =>
      state.transportOperators.transportOperatorsList || [],
  );

  const workspaceSelected = useSelector(
    (state: ApplicationState) =>
      state.transportOperators.transportOperatorSelected || [],
  );

  const open = useSelector((state: ApplicationState) => state.drawer.open);

  const collapseList = useSelector(
    (state: ApplicationState) => state.collapse.collapseList,
  );

  const [mouseOverLogo, setMouseOverLogo] = React.useState(false);
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

  const handleOpenWorkspaces = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseWorkspaces = () => {
    setAnchorEl(null);
  };

  const modules = ['9', '72'];
  const types = ['SUPERVISOR'];

  const handleUploadImage = () => {
    dispatch(
      setOpen({
        open: true,
        content: (
          <ImageUpload
            handleSubmit={(base64: string) =>
              dispatch(
                TransportOperatorsActions.updateTransportOperatorRequest({
                  transportOperatorId: workspaceSelected.id,
                  name: workspaceSelected.name,
                  picture: base64,
                }),
              )
            }
          />
        ),
      }),
    );
  };

  useEffect(() => {
    setisConsortion(transportOperatorSelected.type === CONSORTION_TYPE);
  }, []);

  return (
    <Box>
      <Box
        className={clsx(classes.company, {
          [classes.companyCloseDrawer]: !open,
        })}>
        {open && (
          <Box
            className={classes.logoContainer}
            onClick={() => handleUploadImage()}
            onMouseOver={() => setMouseOverLogo(true)}
            onMouseOut={() => setMouseOverLogo(false)}>
            {workspaceSelected.photoUrl != null &&
            workspaceSelected.photoUrl !== '' ? (
              <ImgMedia
                alt='Logo'
                component='img'
                src={workspaceSelected.photoUrl || ''}
              />
            ) : null}
            <ImgMedia
              alt='Atualizar Logo'
              component='img'
              src={IMAGES.ICONS.WHITE_PENCIL}
              className={clsx(classes.logoUpdate, {
                [classes.hiddenImage]: !mouseOverLogo,
              })}
            />
          </Box>
        )}
        {!open && (
          <IconButton
            aria-haspopup='true'
            aria-controls='menu-company'
            onClick={handleOpenWorkspaces}>
            <Box className={classes.logoContainer}>
              <ImgMedia
                alt=''
                component='img'
                src={workspaceSelected.photoUrl || ''}
              />
            </Box>
          </IconButton>
        )}
        <Typography component='span' className={classes.companyLabel}>
          {workspaceSelected.name}
        </Typography>
        <Box>
          <Menu
            keepMounted
            id='menu-company'
            anchorEl={anchorEl}
            onClose={handleCloseWorkspaces}
            open={Boolean(anchorEl)}>
            {workspaces &&
              workspaces.length > 0 &&
              workspaces.map((workspace: any) => (
                <MenuItem
                  key={workspace.id}
                  onClick={() => {
                    dispatch(
                      TransportOperatorsActions.selectTransportOperatorRequest({
                        transportOperatorSelected: workspace,
                        refresh: true,
                      }),
                    );
                    setCompany(workspace.id);
                    handleCloseWorkspaces();
                  }}>
                  {workspace.name}
                </MenuItem>
              ))}
          </Menu>
          <IconButton
            classes={{
              root: clsx({ [classes.expandIcon]: !open }),
            }}
            aria-haspopup='true'
            aria-controls='menu-company'
            onClick={handleOpenWorkspaces}>
            <ExpandMore className={classes.expand} />
          </IconButton>
        </Box>
      </Box>

      <Box>
        <MenuCollapse
          isConsortion={isConsortion}
          moduleConsortionHasAutorization={true}
          moduleConsortionHasAllAutorization={true}
          types={types}
          modules={modules}
          title='Gerenciamento'
          open={
            collapseList.filter((item) => item.title === 'Gerenciamento')[0]
              .open
          }
          icon={
            <Settings
              className={clsx(classes.settingsIcon, {
                [classes.marginIcon]: !open,
              })}
            />
          }
          items={[
            {
              title: '',
              subtitle: 'Empresa',
              pathRoute: PATH.COMPANY_MANAGEMENT.BASE_URL,
              modules: ['9'],
            },
            {
              title: '',
              subtitle: 'Sistema',
              pathRoute: PATH.SYSTEM_MANAGEMENT.BASE_URL,
              modules: ['72'],
            },
          ]}
        />
      </Box>
    </Box>
  );
};

export default SupervisorHeader;
export { SupervisorHeader };
